import BasicRouterView from "../../components/BasicRouterView.vue";

const produtosNovoRoutes = {
  path: "prodn",
  redirect: { name: "produtos-lista-novo" },
  meta: {
    label: "Produtos - Novo",
    icon: "shopping_cart",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "produto/lista-produtos-novo",
      name: "produtos-lista-novo",
      meta: {
        label: "Listar",
        icon: "qr_code_scanner",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/ListarProdutos.vue"),
    },
    {
      path: "produto-novo/imprimir-etiqueta/:produtoId/:contractId",
      name: "imprimir-etiqueta-novo",
      meta: {
        label: "Imprimir",
        icon: "qr_code_scanner",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ImprimirEtiqueta.vue"
        ),
    },
    {
      path: "produto-novo/imprimir-opcional/:produtoId/:contractId",
      name: "imprimir-etiqueta-opcional",
      meta: {
        label: "Imprimir",
        icon: "qr_code_scanner",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "produtos" */ "./views/ImprimirEtiquetaNovo.vue"
        ),
    },
    {
      path: "produto-novo/categoria-produtos-novo",
      name: "produtos-categoria-novo",
      meta: {
        label: "Categorias",
        icon: "category",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/Categorias.vue"),
    },
    {
      path: "produto-novo/gestao-epi-produtos-novo",
      name: "produtos-gestao-epi-novo",
      meta: {
        label: "Gestão EPI's",
        icon: "inventory",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "produtos" */ "./views/GestaoEpis.vue"),
    },
  ],
};

export default produtosNovoRoutes;
